import { Card, Divider, Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import type { DisplayPlatformSetting, SettingDrafts } from '../../types';
import { SettingRow } from '../SettingRow/SettingRow';

const { Text, Title } = Typography;

export interface SettingsSectionProps {
  category: string;
  settings: readonly DisplayPlatformSetting[];
  drafts: SettingDrafts;
  onDraftChange: (setting: DisplayPlatformSetting, input: unknown) => void;
  onApply: (key: string) => void;
  onHistory: (key: string) => void;
}

export function SettingsSection({
  category,
  settings,
  drafts,
  onDraftChange,
  onApply,
  onHistory,
}: SettingsSectionProps) {
  const { t } = useTranslation('settings');

  return (
    <Card className="platform-settings-section">
      <Flex vertical gap={4} className="platform-settings-section-header">
        <Title level={4}>
          {t(`categories.${category}`, { defaultValue: category })}
        </Title>
        <Text type="secondary">
          {t(`categoryDescriptions.${category}`, { defaultValue: '' })}
        </Text>
      </Flex>

      {settings.map((setting, index) => (
        <div key={setting.key}>
          {index > 0 ? <Divider /> : null}
          <SettingRow
            setting={setting}
            draftValue={drafts[setting.key]}
            isDirty={setting.key in drafts}
            onChange={(input) => onDraftChange(setting, input)}
            onApply={() => onApply(setting.key)}
            onHistory={() => onHistory(setting.key)}
          />
        </div>
      ))}
    </Card>
  );
}
